import { render, staticRenderFns } from "./addMoreCardDialog.vue?vue&type=template&id=57f08cf2&lang=pug"
import script from "./addMoreCardDialog.vue?vue&type=script&lang=js"
export * from "./addMoreCardDialog.vue?vue&type=script&lang=js"
import style0 from "./addMoreCardDialog.vue?vue&type=style&index=0&id=57f08cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports